// extracted by mini-css-extract-plugin
module.exports =  {"root":"oLW2OfidoQDo9p8TL8YS","body":"U2rRM3a8RIz6yi2d5Jkm","heading":"HreOaKi1I6kBLIThi1Tu","list":"dQ_8pSSrfTmzzmdjPabR","noResults":"mpJCYZ1QIrI18wH0fs0t"};